import { ChevronRight } from 'lucide-react';

// Card Component
const CoverPageCard = ({
    icon: Icon,
    title,
    description,
    linkText,
    linkHref,
    iconColor = 'text-primary',
}) => {
    return (
        <div className="bg-neutral-50 rounded-xl border border-neutral-300 p-6 h-full flex flex-col justify-between">
            <div className={`${iconColor} py-4`}>
                <Icon className="h-12 w-12" />
            </div>
            <div>
                <h3 className="mb-3">{title}</h3>
                <p className="text-neutral-700 mb-4">{description}</p>
                <a
                    href={linkHref}
                    className="inline-flex items-center text-primary font-semibold hover:text-accent"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {linkText} <ChevronRight className="ml-2 h-4 w-4" />
                </a>
            </div>
        </div>
    );
};

export default CoverPageCard;
